module.exports = __webpack_public_path__ + "img/foxie-eliana.f47604b0.png";